import React from 'react';

import { IIconProps, TIconType } from '../interface';

const ClearFilesIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='22'
			viewBox='0 0 23 22'
			width='23'
			{...props?.innerSvgProps}
		>
			<path
				d='M5.08398 20.1654H17.9173C18.4035 20.1654 18.8699 19.9722 19.2137 19.6284C19.5575 19.2846 19.7507 18.8183 19.7507 18.332V6.41536L15.1673 1.83203H6.91732C6.43109 1.83203 5.96477 2.02519 5.62096 2.369C5.27714 2.71282 5.08398 3.17913 5.08398 3.66536V7.33203'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.2503 1.83203V5.4987C14.2503 5.98493 14.4435 6.45124 14.7873 6.79506C15.1311 7.13888 15.5974 7.33203 16.0837 7.33203H19.7503M8.75033 11.457L4.16699 16.0404M4.16699 11.457L8.75033 16.0404'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ClearFilesIcon;
